import { Span, Image } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { Screen } from '../Screens/Screen';


export class LaunchingScreen extends Screen
{
    constructor(_lang: Translations)
    {
        super(
            new Span("🚀 " + _lang.Launching).Class("launching-label"),
            "\n" + _lang.ConnectingToServer + "...\n",
            new Image("loading.gif").Width(28).Margin(16),
            "\n",
            new Span(_lang.PleaseStandBy).Class("launching-line")
        );
    }
}
